import {Table, Typography} from "antd";
import Utils from "../../../../../../utils/utils";
import {TableItemStatus} from "../../../../../../componets/ui";
import {useTranslation} from "react-i18next";
import { PaymentStatus } from "utils/constants";
import {ProcessedPaymentSchedule} from "../../../../../../models/Project";
import {ColumnTypes} from "../../../../../../models";

type PrimaryMarketProcessedPaymentsProps = {
	data?: ProcessedPaymentSchedule[]
}

export const PrimaryMarketProcessedPayments = (
	{ data = [] }: PrimaryMarketProcessedPaymentsProps
) => {
	const { t } = useTranslation();
	return (
		<div className="primaryItem__block">
			<Typography.Title className="primaryItem__blockTitle" level={4}>
				{t('processedPaymentsTitle')}
			</Typography.Title>
			<Table
				className="accountTable accountTable__paymentSchedule"
				columns={[
					{
						title: t('paymentDate'),
						dataIndex: 'paymentDate',
						render: (v) => <span className="nobr">{v}</span>
					},
					{
						title: t('principalPaymentText'),
						dataIndex: 'principalAmount',
						render: (amount: number) => {
							return Utils.moneyFormat(amount);
						},
					},
					{
						title: t('interestPaymentText'),
						dataIndex: 'interestAmount',
						render: (amount: number) => {
							return Utils.moneyFormat(amount);
						},
					},
					{
						title: t('paymentType'),
						dataIndex: 'paymentType',
						render: (v) => {
							return t(`paymentTypes_${v}`);
						}
					},
					{
						title: t('paymentStatusText'),
						dataIndex: 'status',
						render: (status: string) => {
							switch (status) {
								case PaymentStatus.DONE:
								case PaymentStatus.PAID:
								case PaymentStatus.PAY_WITH_DELAY:
									return <TableItemStatus
										status={PaymentStatus.PAID}
										isGreen={true}
										isRed={false}
									/>
								default:
									return <TableItemStatus
										status={status}
										isRed={status === PaymentStatus.LATE || status === PaymentStatus.PAY_WITH_DELAY}
										isGreen={status === PaymentStatus.PAID}
									/>
							}
						},
					},
				] as ColumnTypes}
				dataSource={data}
				pagination={false}
				scroll={{ x: 670 }}
			/>
		</div>
	)
}
